import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootreducer";
import { envConfig } from "../utils/config";

const store = configureStore({
    reducer: rootReducer as any,
    devTools: envConfig.REDUX_DEV_TOOL,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware();
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;